import { combineReducers } from 'redux';
import companyReducer from './companyReducer';
import companyInfoReducer from './companyInfoReducer';
import transactionDetailsReducer from './transactionDetailsReducer';
import userSessionReducer from './userSessionReducer';
import backPathReducer from './backPathReducer'; 
import rebateSummarySearchReducer from './rebateSummarySearchReducer'; 
import rebateSummaryPeriodReducer from './rebateSummaryPeriodReducer'; 
import rebateFrequencyReducer from './rebateFrequencyReducer';
import workflowEligibleReducer from './workflowEligibleReducer'; 
import workflowStatusReducer from './workflowStatusReducer'; 
import companyProfileSearchReducer from './companyProfileSearchReducer'; 
import subCompanySearchReducer from './subCompanySearchReducer'; 
import adhocPaymentSearchReducer from './adhocPaymentSearchReducer'; 
import consortiumSearchReducer from './consortiumSearchReducer'; 
import contractSearchReducer from './contractSearchReducer'; 
import consortiumIdReducer from './consortiumIdReducer'; 
import rebatePortfolioReducer2 from './rebatePortfolioReducer2'; 
import workflowTypeReducer from './workflowTypeReducer'; 
import workflowIndicatorReducer from './workflowIndicatorReducer'; 
import companyTypeFilterReducer1 from './companyTypeFilterReducer1'; 
import rebatePortfolioReducer1 from './rebatePortfolioReducer1'; 
import companyTypeFilterReducer2 from './companyTypeFilterReducer2'; 
import companyTypeFilterReducer3 from './companyTypeFilterReducer3'; 
import rebatePortfolioReducer3 from './rebatePortfolioReducer3'; 
import footerConfigReducer from './footerConfigReducer';
import attributesReducer from './attributesReducer'; 

const reducers = combineReducers({
    company: companyReducer,
    companyInfo: companyInfoReducer,
    transactionDetails: transactionDetailsReducer,  
    userSession: userSessionReducer, 
    backPath: backPathReducer,
    rebateSummarySearch: rebateSummarySearchReducer, 
    rebateSummaryPeriod: rebateSummaryPeriodReducer, 
    rebateFrequency: rebateFrequencyReducer, 
    workflowEligible: workflowEligibleReducer,
    workflowStatus: workflowStatusReducer, 
    companyProfileSearch: companyProfileSearchReducer, 
    subCompanySearch: subCompanySearchReducer, 
    adhocPaymentSearch: adhocPaymentSearchReducer, 
    consortiumSearch: consortiumSearchReducer, 
    contractSearch: contractSearchReducer, 
    consortiumId: consortiumIdReducer,
    rebatePortfolio2: rebatePortfolioReducer2, 
    workflowType: workflowTypeReducer, 
    workflowIndicator: workflowIndicatorReducer, 
    companyTypeFilter1: companyTypeFilterReducer1, 
    rebatePortfolio1: rebatePortfolioReducer1, 
    companyTypeFilter2: companyTypeFilterReducer2, 
    companyTypeFilter3: companyTypeFilterReducer3, 
    rebatePortfolio3 :rebatePortfolioReducer3,
    footerConfig: footerConfigReducer,
    attributes: attributesReducer
});
 
export default reducers; 